<template>
  <!-- 广告页面弹窗 -->
  <GtcModal class="advertising-modal-page" v-model:open="open" width="487px">
    <div class="w-full h-[250px] rounded-[16px] overflow-hidden mt-[24px]">
      <img class="w-full h-full" :src="curAdvertising?.pic" alt="" />
    </div>
    <div class="content text-ink-950 my-[24px]">
      <div class="text-[20px] font-semibold">{{ t('modals.common.advertising.title') }}</div>
      <div
        class="text-[16px] leading-[24px] h-[192px] line-clamp-8"
        v-html="curAdvertising?.content"
      ></div>
    </div>
    <template #footer>
      <div class="flex justify-end">
        <GtcButton type="primary" size="md" @click="handleOk">{{
          t('modals.common.advertising.button.viewDetails')
        }}</GtcButton>
      </div>
    </template>
  </GtcModal>
</template>

<script setup lang="ts">
import { useAdvertisingStore } from '@/store/advertising'
import { storeToRefs } from 'pinia'
import { GtcModal, GtcButton } from '@/components'
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const { curAdvertising, advertising } = storeToRefs(useAdvertisingStore())

const open = ref(false)
const emit = defineEmits<{
  (e: 'readAdvertising'): void
}>()

const handleOk = () => {
  window.open(curAdvertising?.value.open_url)
  open.value = false
}

watch(open, async (newVal) => {
  if (!newVal) {
    await emit('readAdvertising')
    advertising.value.shift()
  }
})

defineExpose({
  open,
})
</script>

<style lang="less" scoped></style>
